import isString from 'strings/isString'

export default (value) => isString(value) && value.replace(/(\*)+/gi, '.*')
